import {ServiceBase} from '../ServiceBase';
import {IDeviceService} from './device.service.interface';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {DeviceInfo} from '../sdk/cgp-sdk.interface';
import { action, observable, makeObservable } from 'mobx';
import Device from "../../../sdk/src/utils/device/device";

export class DeviceService extends ServiceBase implements IDeviceService {
  constructor(services: IServiceFactoryExtended) {
    super(services);

    makeObservable(this);

    this._updateDeviceType();
    this.services.dom.subscribeTo.devicechanged(this._updateDeviceType);
  }

  private get _sdkDevice(): DeviceInfo {
    return this.services.sdk.device;
  }

  @action.bound
  private _updateDeviceType() {
    this.isMobile = this._sdkDevice.isMobile();
    this.isTablet = this._sdkDevice.isTablet();

    this.os = this._sdkDevice.os;
    this.browser = this._sdkDevice.browser;
    this.hybrid = this._sdkDevice.hybrid;
    this.feature = this._sdkDevice.feature;
    this.model = this._sdkDevice.model;
    this.viewport = this._sdkDevice.viewport;
    this.isProgressiveWebApp = this._sdkDevice.isProgressiveWebApp;

    this.isStandalone = this._sdkDevice.isStandalone;

    this.segments = {
      isMobile: this.isMobile,
      deviceType: this.isMobile ? 'mobile' : 'pc',
      isHybrid: this.hybrid.isHybrid,
      isEmbeddedHybrid: this.hybrid.isEmbedded,
      operationSystem: this.os.name,
      tool: Device.isProbablyIPad ? "tablet" : '',
      isProgressiveWebApp: this._sdkDevice.isProgressiveWebApp
    };
  }

  /** @deprecated */
  @observable.ref
  isMobile: boolean;
  /** @deprecated */
  isTablet: boolean;

  os: DeviceInfo["os"];
  browser: DeviceInfo["browser"];
  model: DeviceInfo["model"];
  hybrid: DeviceInfo["hybrid"];
  feature: DeviceInfo["feature"];
  viewport: DeviceInfo["viewport"];
  isProgressiveWebApp: DeviceInfo["isProgressiveWebApp"];

  isStandalone: boolean;

  @observable.ref
  segments: {
    [key: string]: any;
  }

  get productPackageId(): number {
    return this.services.sdk.getProductPackageId();
  }

  get isMobileWebApp(): boolean {
    return Device.isMobileWebApp;
  }

  get isProbablyIOSDevice(): boolean {
    return Device.isProbablyIOSDevice;
  }
}
